import cn from "@utils/cn";

const CLASS_NAMES = cn(`
  flex
  items-center
  gap-3
  px-5
  py-3
  text-sm
  font-normal
  tracking-wider
  uppercase
  select-none

  text-white/80
`);

export default function DrawerHeadingItem(props) {
  const {
    label,
  } = props;

  const {
    text,
  } = label;

  return (
    <div className={CLASS_NAMES}>
      {text}
    </div>
  );
}
